<template lang="pug">
  .card
    .card-body
      h4.card-title.text-center.d-flex.justify-content-between
        i.fa.fa-chevron-left(@click.prevent="prev()")
        span Emergency Contact / Beneficiaries
        i.fa.fa-chevron-right(@click.prevent="next()")
      hr
      .row
        .col-md-8
          ValidationObserver(ref="Validation" slim)
            ValidationProvider(name="contact person" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="contact_person") Contact person in case of emergency:
                input.form-control#contact_person(:class="{'border-danger': errors.length}" type="text" name="contact_person" placeholder="" v-model="form.contactPerson")
                small.text-danger(v-if="errors.length") {{ errors[0] }}
            ValidationProvider(name="contact number" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="contact_number") Contact number:
                input.form-control#contact_number(:class="{'border-danger': errors.length}" type="text" name="contact_number" placeholder="" v-model="form.contactNumber")
                small.text-danger(v-if="errors.length") {{ errors[0] }}
            ValidationProvider(name="beneficiary (1)" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="beneficiary_1") Beneficiary (1):
                input.form-control#beneficiary_1(:class="{'border-danger': errors.length}" type="text" name="beneficiary_1" placeholder="" v-model="form.beneficiary1")
                small.text-danger(v-if="errors.length") {{ errors[0] }}
            ValidationProvider(name="beneficiary (2)" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="beneficiary_2") Beneficiary (2):
                input.form-control#beneficiary_2(:class="{'border-danger': errors.length}" type="text" name="beneficiary_2" placeholder="" v-model="form.beneficiary2")
                small.text-danger(v-if="errors.length") {{ errors[0] }}
            ValidationProvider(name="beneficiary (3)" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="beneficiary_3") Beneficiary (3):
                input.form-control#beneficiary_3(:class="{'border-danger': errors.length}" type="text" name="beneficiary_3" placeholder="" v-model="form.beneficiary3")
                small.text-danger(v-if="errors.length") {{ errors[0] }}
</template>

<style scoped=""></style>

<script>
  import { ref, reactive } from '@vue/composition-api'
  
  export default {
    name: 'step_3',
    props: {
      value: {
        type: Object,
        required: true
      }
    },
    emits: ['prev', 'next', 'input'],

    setup(props, {emit}) {
      const form = reactive(props.value)
      const Validation = ref(null)
      const prev = () => {
        emit('prev');
      }
      const next = () => {
        emit('next');
      }
      const validate = () => {
        emit('input', form)
        return Validation.value.validate()
          .then(success => {
            if(success) {
              return Promise.resolve(success)
            }
            return Promise.reject(success)
          })
      }
      return {
        form,
        Validation, prev, next, validate
      }
    }
  }
</script>